<div *transloco="let t">
	<ng-template #readingValueDevicesTable let-consumptionPeriod="consumptionPeriod" let-costType="costType">
		<table @stagger [dataSource]="toDataSource(consumptionPeriod.deviceConsumptions)" class="w-full" mat-table>
			<ng-container matColumnDef="roomType">
				<th *matHeaderCellDef mat-header-cell>
					{{ t('uviPercentage.roomType') }}
				</th>
				<td *matCellDef="let row" [attr.data-label]="t('uviPercentage.roomType')" mat-cell>
					{{ row.roomType === 'OTHER' ? row.roomName : t('roomType.' + row.roomType) }}
				</td>
			</ng-container>

			<ng-container matColumnDef="deviceNumber">
				<th *matHeaderCellDef mat-header-cell>
					{{ t('devices.deviceNumber') }}
				</th>
				<td *matCellDef="let row" [attr.data-label]="t('devices.deviceNumber')" mat-cell>
					{{ row.deviceNumber }}
				</td>
			</ng-container>

			<ng-container matColumnDef="transmitterNumber">
				<th *matHeaderCellDef mat-header-cell>
					{{ t('uviPercentage.transmitterNumber') }}
				</th>
				<td *matCellDef="let row" [attr.data-label]="t('uviPercentage.transmitterNumber')" mat-cell>
					{{ row.transmitterNumber }}
				</td>
			</ng-container>
			<ng-container matColumnDef="deviceType">
				<th *matHeaderCellDef mat-header-cell>
					{{ t('devices.deviceType') }}
				</th>
				<td *matCellDef="let row" [attr.data-label]="t('devices.deviceType')" mat-cell>
					{{ t('enum.' + row.deviceType) }}
				</td>
			</ng-container>

			<ng-container matColumnDef="periodBeginValue">
				<th *matHeaderCellDef mat-header-cell>
					<div class="flex flex-col justify-center items-end">
						<div class="pt-4">
							{{ t('readingValues.readingValue') }}
						</div>
						<div class="text-xs -mb-1">
							{{ readingDateBegin(consumptionPeriod) }}
						</div>
					</div>
				</th>
				<td *matCellDef="let row" [attr.data-label]="t('readingValueInfo.oldValue')" class="text-end" mat-cell>
					{{ withUnit({ consumption: row.periodBeginValue, consumptionUnit: row.unit }) }}
				</td>
			</ng-container>

			<ng-container matColumnDef="periodEndValue">
				<th *matHeaderCellDef class="text-end" mat-header-cell>
					<div class="flex flex-col justify-center items-end">
						<div class="pt-4">
							{{ t('readingValues.readingValue') }}
						</div>
						<div class="text-xs -mb-1">
							{{ readingDateEnd(consumptionPeriod) }}
						</div>
					</div>
				</th>
				<td *matCellDef="let row" [attr.data-label]="t('readingValueInfo.newValue')" class="text-end" mat-cell>
					{{ withUnit({ consumption: row.periodEndValue, consumptionUnit: row.unit }) }}
				</td>
			</ng-container>

			<ng-container matColumnDef="factor">
				<th *matHeaderCellDef class="text-end" mat-header-cell>
					{{ t('uviCalc.factor') }}
				</th>
				<td *matCellDef="let row" [attr.data-label]="t('uviCalc.factor')" class="text-end" mat-cell>
					@if (row.deviceType === DeviceTypeEnum.ALLOCATOR) {
						{{ this.numberUtil.scaleAndReplaceDot(row.factor, 3) }}
					}
				</td>
			</ng-container>

			<ng-container matColumnDef="consumption">
				<th *matHeaderCellDef class="text-end" mat-header-cell>
					{{ t('uviPercentage.consumption') }}
				</th>
				<td *matCellDef="let row" [attr.data-label]="t('uviPercentage.consumption')" class="text-end" mat-cell>
					{{ this.numberUtil.scaleAndReplaceDot(row.consumption, 2) }} {{ row.consumption === undefined ? '' : t('enum.' + row.unit) }}
				</td>
			</ng-container>
			<ng-container matColumnDef="chart">
				<th *matHeaderCellDef mat-header-cell>
					{{ t('uviPercentage.chart') }}
				</th>
				<td *matCellDef="let row" [attr.data-label]="t('uviPercentage.chart')" mat-cell>
					@if (row.barChartLength > 0) {
						<div
							[class]="anyDeviceNotTransmitted ? 'chart-color-deactivated' : 'chart-color'"
							[style.width]="row.barChartLength + '%'"
							[style.max-height]="this.layoutService.isMobile() ? '20px' : ''"></div>
					}
				</td>
			</ng-container>
			<ng-container matColumnDef="percentShare">
				<th *matHeaderCellDef class="text-end" mat-header-cell>
					{{ t('uviPercentage.percentageShare') }}
				</th>
				<td *matCellDef="let row" [attr.data-label]="t('uviPercentage.percentageShare')" class="text-end" mat-cell>
					<div [ngClass]="anyDeviceNotTransmitted ? 'text-zinc-300' : ''">
						{{ anyDeviceNotTransmitted && !row.percentShare ? '--' : row.percentShare + ' %' }}
					</div>
				</td>
			</ng-container>

			<ng-container matColumnDef="information">
				<th *matHeaderCellDef class="text-center" mat-header-cell>
					{{ t('uviPercentage.info') }}
				</th>
				<td *matCellDef="let row" [attr.data-label]="t('uviPercentage.information')" class="text-center" mat-cell>
					<button
						(click)="showReadingValueInfo(row.energyBaseCalculation, row.deviceType, row.deviceNumber)"
						aria-label="Edit"
						class="hover-button"
						color="primary"
						mat-icon-button>
						<mat-icon [svgIcon]="icons.get('info')">information</mat-icon>
					</button>
				</td>
			</ng-container>

			<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
			<tr
				*matRowDef="let row; columns: displayedColumns"
				@fadeInUp
				[ngClass]="row.consumption > -1 ? '' : 'text-zinc-300'"
				class="hover:bg-hover trans-ease-out"
				mat-row></tr>

			<!-- Row shown when there is no matching data. -->
			<tr *matNoDataRow class="mat-row">
				<td class="mat-cell" colspan="4">
					<div class="ml-4">{{ t('dashboard.noDataFound') }}</div>
				</td>
			</tr>
		</table>

		<div class="py-6 flex flex-col justify-center items-start">
			@if (costType !== CostTypeEnum.COLDWATER) {
				<div class="pb-4" style="font-weight: bold">
					{{ t('uviPercentage.energyConsumed') }}
				</div>
			}
			@for (deviceConsumptionSummary of consumptionPeriod.deviceConsumptionSummaries; track deviceConsumptionSummary) {
				<div class="flex flex-row justify-between items-center">
					<div [ngClass]="layoutService.isMobile() ? 'w-[9rem]' : 'w-[21rem]'">
						{{ t('uviPercentage.energyConsumedSummed') }} {{ t('enum.' + deviceConsumptionSummary.deviceType + '_long') }}
					</div>
					<div class="float-end">
						{{ withUnit(deviceConsumptionSummary) }}
					</div>
				</div>
			}
			@if (costType !== CostTypeEnum.COLDWATER && costType !== CostTypeEnum.COOLING) {
				<div class="flex flex-row" style="width: 100%">
					<div class="flex flex-row justify-between items-center">
						<div [ngClass]="layoutService.isMobile() ? 'w-[9rem]' : 'w-[21rem]'">
							{{ t('uviPercentage.energyConsumedkWh') }}
						</div>
						<div>
							{{ appendKwh(consumptionPeriod.totalConsumptionAsKwh) }}
						</div>
					</div>
					<button (click)="showCalculationInfo(consumptionPeriod)" aria-label="Edit" color="primary" mat-icon-button>
						<mat-icon [svgIcon]="icons.get('info')">information</mat-icon>
					</button>
				</div>
			}
		</div>
	</ng-template>
	<ng-template
		*ngTemplateOutlet="
			readingValueDevicesTable;
			context: { consumptionPeriod: consumption().currentConsumptionPeriod, costType: consumption().costType }
		"></ng-template>
</div>
